
import React, { useState, useEffect} from "react";
import apiFetcher from "../../utils/apiFetcher";


const CredentialsForm = ({ calendar }) => {

  const { setFormPage, userData, setUserData, setIsLoggedIn } = calendar;
  const [isRegularExiting, setIsRegularExiting] = useState(false);
  const [isQuestExiting, setIsQuestExiting] = useState(false);
  const [isRegisterExiting, setIsRegisterExiting] = useState(false);
  const [isExtraFieldsVisible, setIsExtraFieldsVisible] = useState(false);
  const animationDuration = 300;
  const [userChoose, setUserChoose] = useState("quest")
  const [error, setError] = useState("");
  const token = localStorage.getItem("jwt");

  const handleInputChange = (e) => {
    const { id, value } = e.target;
    let newValue = value.trim();
  
    if (id === "telephoneNumber") {
      newValue = value.replace(/\s/g, "");
    }
  
    setUserData({ ...userData, [id]: newValue });
  };

  

  const validateRegistration = () => {
    const { name, surname, email, telephoneNumber, password, repeatPassword } = userData;
    if (!name || !surname || !email || !telephoneNumber || !password || !repeatPassword) {
      setError("Wszystkie pola muszą być wypełnione");
      return false;
    }
    if (!/^(?=.*[a-z])(?=.*\d).{8,}$/.test(password)) {
      setError("Nieprawidłowy format hasła");
      return false;
    }
    if (password !== repeatPassword) {
      setError("Hasła się nie zgadzają");
      return false;
    }
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      setError("Nieprawidłowy format e-mail");
      return false;
    }
    if (!/^[0-9]+.{8,}$/.test(telephoneNumber)) {
      setError("Nieprawidłowy numer telefonu");
      return false;
    }
    return true;
  };



  const handleSubmit = async () => {
    function firtsLetterUpercase(string) {
      const modifiedString = string.toLowerCase();
      return modifiedString.charAt(0).toUpperCase() + modifiedString.slice(1);
  }
    if (userChoose === "register") {
      if (validateRegistration()) {
        userData.name = firtsLetterUpercase(userData.name);
        userData.surname = firtsLetterUpercase(userData.surname);
        userData.email = userData.email.toLowerCase();
        const loggedUser = await apiFetcher.sendUserData("register", {
          name: userData.name,
          surname: userData.surname,
          email: userData.email,
          password: userData.password,
          telephoneNumber: userData.telephoneNumber,
        });
        if (loggedUser.confirmed) {
          setIsLoggedIn(true);
          setFormPage(3)
        }else {
          setError(`Ten adres e-mail już istnieje!`)
        }
      }
    } else if (userChoose === "login") {
      const loggedUser = await apiFetcher.sendUserData("login", {
        email: userData.email,
        password: userData.password,
      });
      if (loggedUser.confirmed) {
          setIsLoggedIn(true);
          setFormPage(3)
      }
      else setError("Nieprawidłowy email lub hasło!");
    }else {
      if(userData.name !=='' && 
        userData.telephoneNumber !== '' && 
        userData.surname !== '') {
          setFormPage(3);
          
      }else {
        setError(`Wypełnij wszystkie pola!`)
      }
    }
  };


  const handleUserChooseChange = (newChoice) => {
    if (newChoice === "quest") {
      setIsRegularExiting(true);
      setTimeout(() => {
        setUserChoose(newChoice);
        setIsRegularExiting(false);
      }, animationDuration);
    } else {
      setIsQuestExiting(true);
      setTimeout(() => {
        setUserChoose(newChoice);
        setIsQuestExiting(false);
      }, animationDuration);
    }
  };


  const handleRegisterToggle = (newChoice) => {
    if (newChoice === "register" && userChoose === "login") {
      setUserChoose(newChoice);
      setIsExtraFieldsVisible(true);
    } else if (newChoice === "login" && userChoose === "register") {
      setIsExtraFieldsVisible(false);
      setTimeout(() => {
        setUserChoose(newChoice);
      }, animationDuration);
    } else {
      setUserChoose(newChoice);
    }
  };


  useEffect(() => {
    if (userChoose === "register") {
      setIsExtraFieldsVisible(true);
    }
  }, [userChoose]);
  

  return (
<div>
      {/* <div id="toggle-switch-container">
        <h5 className="toggle-switch-label">Strefa stałego klienta</h5>
        <div className="toggle-switch">
          <input
            type="checkbox"
            id="regular-customer-switch"
            onChange={(e) => handleUserChooseChange(e.target.checked ? "login" : "quest")}
          />
          <label htmlFor="regular-customer-switch"></label>
        </div>
      </div> */}

      <div id="input-form">
        <div
          className={`container ${
            userChoose !== "quest" && !isRegularExiting
              ? userChoose === "register" && isExtraFieldsVisible
                ? "expanded-full"
                : "expanded"
              : "collapsed"
          }`}
          id="regular-customer-container"
        >
          {(userChoose !== "quest" || isRegularExiting) && (
            <>
              <div className="login-container">
                <div className="login-or-register">
                  <h4
                    className={`option ${userChoose === "login" ? "selected-option" : "unselected-option"}`}
                    onClick={() => handleRegisterToggle("login")}
                  >
                    Zaloguj się
                  </h4>
                  <h4
                    className={`option ${userChoose === "register" ? "selected-option" : "unselected-option"}`}
                    onClick={() => handleRegisterToggle("register")}
                  >
                    Zarejestruj się
                  </h4>
                </div>
                <div className="fields">
                  <input
                    id="email"
                    placeholder="E-mail"
                    type="email"
                    value={userData.email}
                    onChange={handleInputChange}
                    onKeyDown={(e) => e.key === 'Enter' && handleSubmit}
                  />
                  <input
                    id="password"
                    placeholder="Hasło (minimum 8 znaków)"
                    type="password"
                    value={userData.password}
                    onChange={handleInputChange}
                    onKeyDown={(e) => e.key === 'Enter' && handleSubmit}
                  />
                  <div
                    className={`extra-fields ${isExtraFieldsVisible ? "expanded" : "collapsed"}`}
                  >
                    {(userChoose === "register" || isExtraFieldsVisible) && (
                      <>
                        <input
                          id="repeatPassword"
                          placeholder="Powtórz hasło"
                          type="password"
                          value={userData.repeatPassword}
                          onChange={handleInputChange}
                          onKeyDown={(e) => e.key === 'Enter' && handleSubmit}
                        />
                        <input
                          id="name"
                          placeholder="Imie"
                          type="text"
                          value={userData.name}
                          onChange={handleInputChange}
                          onKeyDown={(e) => e.key === 'Enter' && handleSubmit}
                        />
                        <input
                          id="surname"
                          placeholder="Nazwisko"
                          type="text"
                          value={userData.surname}
                          onChange={handleInputChange}
                          onKeyDown={(e) => e.key === 'Enter' && handleSubmit}
                        />
                        <input
                          id="telephoneNumber"
                          placeholder="Numer telefonu (bez spacji)"
                          type="text"
                          value={userData.telephoneNumber}
                          onChange={handleInputChange}
                          onKeyDown={(e) => e.key === 'Enter' && handleSubmit}
                        />
                      </>
                    )}
                  </div>
                </div>
              </div>
              <button id="submit-button" onClick={handleSubmit}>
                <h3>Dalej →</h3>
              </button>
            </>
          )}
        </div>

        <div
          className={`container ${userChoose === "quest" && !isQuestExiting ? "expanded" : "collapsed"}`}
          id="basic-customer-container"
        >
          {(userChoose === "quest" || isQuestExiting) && (
            <>
              <p>Dane kontaktowe</p>
              <div className="login-container">
                <div className="fields">
                  <input
                    id="name"
                    placeholder="Imie"
                    type="text"
                    value={userData.basicName}
                    onChange={handleInputChange}
                  />
                  <input
                    id="surname"
                    placeholder="Nazwisko"
                    type="text"
                    value={userData.basicSurname}
                    onChange={handleInputChange}
                  />
                  <input
                    id="telephoneNumber"
                    placeholder="Numer telefonu (bez spacji)"
                    type="text"
                    value={userData.basicTelephoneNumber}
                    onChange={handleInputChange}
                  />
                </div>
              </div>
              <button id="submit-button-basic" onClick={() => handleSubmit()}>
                <h3>Dalej →</h3>
              </button>
            </>
          )}
        </div>
        <div>
          <p>Przechodząc dalej wyrażasz zgodę na naszą politykę prywatności.</p>
        </div>
      </div>
      <span id="error">{error}</span>
    </div>
  );
};

export default CredentialsForm;